import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=5057ffa3&scoped=true&"
import script from "./AppTab.vue?vue&type=script&lang=js&"
export * from "./AppTab.vue?vue&type=script&lang=js&"
import style0 from "./AppTab.vue?vue&type=style&index=0&id=5057ffa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5057ffa3",
  null
  
)

export default component.exports